<template>
    <div class="float-contact">
        <div class="float-item">
            <div class="popup-box">
                <div class="text">QQ：{{ aboutObj.qq }}</div>
            </div>
            <img src="https://admin.syljhky.com//uploads/20260423/e098ea5edaf46c870dc358129d5a02b6.png" class="icon" />
        </div>

        <div class="float-item">
            <div class="popup-box">
                <img :src="aboutObj.image" class="qrcode" />
                <div class="text">扫码添加微信</div>
            </div>
            <img src="https://admin.syljhky.com//uploads/20260423/e71e2e97f3db42810146cef8ae6643d2.png" class="icon" />
        </div>

        <div class="float-item">
            <div class="popup-box">
                <div class="text">咨询热线：</div>
                <div class="text phone">{{ aboutObj.phone }}</div>
            </div>
            <img src="https://admin.syljhky.com//uploads/20260423/fbe6fdc13a1b4eec8f7e491a03b52cd7.png" class="icon" />
        </div>
    </div>
</template>

<script>
export default {
    props: ['id'],
    data() {
        return {
            aboutObj: '',
        };
    },
    methods: {
        getAbout() {
            this.axios
                .post("/api/index/getAbout")
                .then((res) => {
                    this.aboutObj = res;
                    this.aboutObj.image = "https://admin.syljhky.com//" + this.aboutObj.image;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
    created() {
        this.getAbout();
    },
};
</script>

<style lang="scss" scoped>
.float-contact {
    position: fixed;
    right: 20px;
    bottom: 120px;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 1px;

    .float-item {
        position: relative;
        width: 56px;
        height: 56px;
        background: #1677ff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 6px;

        .icon {
            width: 32px;
            height: 32px;
            object-fit: contain;
        }

        .popup-box {
            position: absolute;
            right: 68px;
            width: 160px;
            background: #fff;
            border-radius: 8px;
            padding: 15px;
            box-shadow: 0 3px 12px rgba(0, 0, 0, 0.15);
            opacity: 0;
            visibility: hidden;
            transition: 0.3s ease;

            .qrcode {
                width: 100%;
                height: auto;
                display: block;
                margin-bottom: 8px;
            }

            .text {
                font-size: 14px;
                color: #333;
                text-align: center;
                white-space: nowrap;

                &.phone {
                    margin-top: 4px;
                }
            }
        }

        &:hover {
            .popup-box {
                opacity: 1;
                visibility: visible;
            }
        }
    }
}
</style>
